﻿// Getter&Setter Delivered / Click & Collect buttons
var deliveryOptionsPersist =
{

    getSelectedDeliveryTypeOption: function () {
        if (this.isLocalStorageSupported()) {
            return window.sessionStorage.getItem('gak_selected_delivery_type_option');
        }
    },
    saveSelectedDeliveryTypeOption: function (selectedDot) {
        if (this.isLocalStorageSupported()) {
            if (!selectedDot) {
                window.sessionStorage.removeItem('gak_selected_delivery_type_option');
            }
            else {
                window.sessionStorage.setItem('gak_selected_delivery_type_option', selectedDot);
            }
        }
    },
    resetSelectedDeliveryTypeOption: function () {
        this.saveSelectedDeliveryTypeOption(null);
    },

    getSelectedDelivery: function () {
        if (this.isLocalStorageSupported()) {
            var tempObj = window.sessionStorage.getItem('gak_selected_delivery_option');
            return tempObj ? JSON.parse(tempObj) : null;
        }
    },
    saveSelectedDelivery: function (selectedDeliveryTypeID, selectedDeliveryDate, isForceSetValues) {
        if (isForceSetValues || (selectedDeliveryTypeID && selectedDeliveryDate)) {
            var newDlv = {
                deliveryTypeID: selectedDeliveryTypeID,
                deliveryDate: selectedDeliveryDate
            };
            if (this.isLocalStorageSupported()) {
                window.sessionStorage.setItem('gak_selected_delivery_option', JSON.stringify(newDlv));
            }
        }
    },

    resetSelectedDelivery: function () {
        this.saveSelectedDelivery(null, null, true);
    },

    // Other functions
    resetAllDelvOpts: function () {
        this.resetSelectedDeliveryTypeOption();
        //saveSelectedDeliveryRegion(null);
        this.resetSelectedDelivery();
    },
    isLocalStorageSupported: function () {
        var testKey = 'test', storage = window.sessionStorage;
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            console.log(error, "isLocalStorageSupported", 59);
            return false;
        }
    }
}

export { deliveryOptionsPersist }